module.exports = __webpack_public_path__ + "VIPH12.png?b47bfceb348c84780b31594d8d779ce8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH12.png
// module id = 84
// module chunks = 0